export const enum UserType {
  INTERNAL = "Internal",
  EXTERNAL = "External"
}

export interface UserRole {
  id: string;
  name: string;
  display_name: string;
}

export interface User {
  id: number;
  username?: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active?: boolean;
  is_admin?: boolean;
  is_onyx?: boolean;
  user_type?: UserType;
  is_service_account?: boolean;
  last_login: string | null;
}

export interface IUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: UserType;
  isActive: boolean;
  lastLogin: string | null;
}

export interface IPostUser {
  email: string;
  first_name: string;
  last_name: string;
  user_type: UserType;
  roles?: string[];
}

export interface UserFormValues {
  email: string;
  firstName: string;
  lastName: string;
  userType: UserType;
  roles?: string;
}

export interface PatchedUser {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  roles: string;
  userType: string;
}

export interface IUsersResponse {
  count: number;
  results: User[];
}

export interface IUserRow extends IUser {
  isEditable: boolean;
  role: string;
  isOnyxUser: boolean;
  isAdmin: boolean;
}

export const isIUserRow = (value: any): value is IUserRow => {
  return (
    value &&
    typeof value.firstName === "string" &&
    typeof value.isOnyxUser === "boolean"
  );
};

export interface IPostDeactivateUsers {
  user_ids: number[];
}
